angular.module('assets')
    .controller('AssetDocumentShowModalController', function ($scope, $uibModalInstance, data, AssetService) {
        this.AssetService = AssetService;

        this.$onInit = () => {
            this.item = data;
        };

        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        $scope.$on('asset-doc.updated', () => this.cancel());
    })
